const AvatarSizeType = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export default AvatarSizeType;
